import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: '🚀',
      title: 'Project Planning',
      description: 'Comprehensive planning and strategy development to ensure your project starts on the right track.'
    },
    {
      icon: '💻',
      title: 'Development & Implementation',
      description: 'Expert development services using the latest technologies and best practices.'
    },
    {
      icon: '🎨',
      title: 'Design & UI/UX',
      description: 'Beautiful, intuitive designs that provide exceptional user experiences.'
    },
    {
      icon: '🔧',
      title: 'Quality Assurance',
      description: 'Rigorous testing and quality control to deliver flawless results.'
    },
    {
      icon: '📊',
      title: 'Project Management',
      description: 'Professional project management ensuring timely delivery and within budget.'
    },
    {
      icon: '🔄',
      title: 'Maintenance & Support',
      description: 'Ongoing support and maintenance to keep your projects running smoothly.'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-description">
            We offer comprehensive project development services to help bring your ideas to life
          </p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
